import { useEffect } from 'react';

type VisibilityChangeHandler = (isVisible: boolean) => void;

export const useDocumentVisibilityDetection = (
  handler: VisibilityChangeHandler,
) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      handler(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handler]);
};
